<div class="icon-container"
     [ngClass]="[horizontalSpace ? horizontalSpace : '', iconName]"
     [ngStyle]="{ 'width.px': iconBgSize, 'height.px': iconBgSize, 'background-color': backgroundColor}">
  <svg [ngStyle]="{ 'width.px': size, 'height.px': size, 'fill': color }">
    <use attr.xlink:href="/assets/symbol-defs.svg#{{ iconName }}"></use>
  </svg>
</div>
